if (!window.customElements.get('gz-protection-plan')) {
  class GzProtectionPlan extends HTMLElement {
    constructor() {
      super();
      this.product = JSON.parse(this.getAttribute("gz-product")) || null;
      this.protectionPlan = JSON.parse(this.getAttribute("gz-protection-plan")) || null;
      this.oemWarranty = JSON.parse(this.getAttribute("gz-oem-warranty")) || null;
      this.planSelected = JSON.parse(this.getAttribute("gz-plan-selected")) || false;
      this.isCartPage = JSON.parse(this.getAttribute("gz-is-cart-page"));
      this.checkbox = this.querySelector("#gz-protection-plan-checkbox");
      this.checkbox?.addEventListener("change", this.togglePlanSelection.bind(this));
      this.addButton = this.querySelector("button[data-add-protection-plan-gz]");
      this.removeButton = this.querySelector("button[data-remove-protection-plan-gz]");
      this.checkoutBtn = document.querySelector("button.cart__checkout-button");

      // Add Protection Plan - Cart Page
      this.addButton?.addEventListener("click", async (e) => {
        e.preventDefault();
        this.isLoading(true);

        try {
          await GzTheme.cartAddPlan(this.product, this.protectionPlan, true);
          await GzTheme.cartSync();
          GzTheme.getSectionsToRender();
        } catch (error) {
          console.error("Failed: Adding protection plan from cart page.", error);
        } finally {
          this.isLoading(false);
        }
      });

      // Remove Protection Plan - Cart Page
      this.removeButton?.addEventListener("click", async (e) => {
        e.preventDefault();
        this.isLoading(true);

        try {
          await GzTheme.cartRemovePlan(this.product, this.oemWarranty);
          await GzTheme.cartSync();
          GzTheme.getSectionsToRender();
        } catch (error) {
          console.error("Failed: Removing protection plan from cart page.", error);
        } finally {
          this.isLoading(false);
        }
      });

      GzTheme.fetchCart();
    }

    connectedCallback() {
      // Add/Update Protection Plan while product being added to cart
      subscribe(PUB_SUB_EVENTS.productAdded, async (event) => {
        this.isLoading(true);
        const addedProduct = event.itemAdded;

        try {
          await GzTheme.pdpAddPlan(
            addedProduct,
            this.protectionPlan,
            this.oemWarranty,
            this.planSelected,
            true
          );
        } catch (error) {
          console.error('Failed to add Protection Plan!', error);
        } finally {
          this.isLoading(false);
          this.resetCheckbox();
        }
      });
   
      // Cart UPDATED event - Update product and protection plan quantities
      subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
        try {
          await GzTheme.cartSync();
        } catch (error) {
          console.error('Error: Failed to fetch cart or update products.', error);
        }
      });

      // variantChange event - Reset protection plan checkbox
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        this.resetCheckbox();
      });
    }

    // Toggle protection plan checkbox - PDP 
    togglePlanSelection(event) {
      this.planSelected = event.target.checked;
    }

    // Reset protection plan checkbox - PDP
    resetCheckbox() {
      this.planSelected = false;
      if(this.checkbox) {
        this.checkbox.checked = false;
      }
    }

    isLoading(isLoading) {
      this.classList.toggle("loading", isLoading);
    
      if (this.checkoutBtn) {
        this.checkoutBtn.disabled = isLoading;
      }
    }
  }
  window.customElements.define('gz-protection-plan', GzProtectionPlan);
}